import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { headerdata } from '../assets/HeaderData';
import { login } from '../store/actions/userLoginAction';
const MenuHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const toggleTestComponents = () => {
    setIsOpen(!isOpen);
  };
  function handleLogout() {
    localStorage.clear();
    dispatch(login.data(null));
    // initialState({ userLogin: null });
  }

  return (
    <nav className='bg-colorTwo '>
      <div className='mx-auto container'>
        <div className='mx-auto  uppercase font-medium'>
          <div className='flex items-center justify-between h-16'>
            <div className='flex items-center'>
              <div className='hidden lg:block'>
                <div className=' flex items-baseline space-x-4'>
                  {headerdata.map((data, index) => (
                    <NavLink
                      key={index}
                      style={({ isActive, isPending }) => {
                        return {
                          fontWeight: isActive ? 'normal' : 'normal',
                          color: isActive ? 'rgb(215, 215, 5)' : 'white',
                          background: isActive ? 'transparent' : 'transparent',
                        };
                      }}
                      className=' text-gray-300 px-3 py-2 rounded-md xl:text-sm text-[10px] font-medium hover:bg-sky-700'
                      to={data.to}
                    >
                      {data.item}
                    </NavLink>
                  ))}
                  {/* <NavLink
                    to='/login'
                    type='button'
                    onClick={handleLogout}
                    className=' text-gray-300 px-3 py-2 rounded-md xl:text-sm text-[10px] font-medium hover:bg-red-700'
                  >
                    Log Out
                  </NavLink> */}
                </div>
              </div>
            </div>
            <div className='-mr-2 flex lg:hidden'>
              <button
                type='button'
                className='bg-gray-900 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white '
                aria-controls='mobile-menu'
                aria-expanded={isOpen}
                onClick={toggleTestComponents}
              >
                <span className='sr-only'>Open main menu</span>
                {/* Heroicon name: menu */}
                <svg
                  className={`block h-6 w-6 ${isOpen ? 'hidden' : ''}`}
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                  aria-hidden='true'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M4 6h16M4 12h16M4 18h16'
                  ></path>
                </svg>
                {/* Heroicon name: x */}
                <svg
                  className={`h-6 w-6 ${isOpen ? '' : 'hidden'}`}
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                  aria-hidden='true'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M6 18L18 6M6 6l12 12'
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div
          className={`lg:hidden ${isOpen ? '' : 'hidden'}`}
          id='mobile-menu'
        >
          <div className='px-2 pt-2 pb-3 space-y-1 sm:px-3 uppercase font-medium '>
            {headerdata.map((data, index) => (
              <NavLink
                key={index}
                style={({ isActive, isPending }) => {
                  return {
                    fontWeight: isActive ? 'normal' : 'normal',
                    color: isActive ? 'rgb(215, 215, 5)' : 'white',
                    background: isActive ? 'transparent' : 'transparent',
                  };
                }}
                onClick={toggleTestComponents}
                className='text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium transition-all duration-500'
                to={data.to}
              >
                {data.item}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MenuHeader;
